
// @ts-nocheck


export const localeCodes =  [
  "de",
  "fr",
  "en",
  "br_de",
  "br_fr",
  "br_en"
]

export const localeLoaders = {
  de: [
    {
      key: "locale_de_46json_96bd13ad",
      load: () => import("#nuxt-i18n/96bd13ad" /* webpackChunkName: "locale_de_46json_96bd13ad" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_0b687afd",
      load: () => import("#nuxt-i18n/0b687afd" /* webpackChunkName: "locale_fr_46json_0b687afd" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_76ef8785",
      load: () => import("#nuxt-i18n/76ef8785" /* webpackChunkName: "locale_en_46json_76ef8785" */),
      cache: true
    }
  ],
  br_de: [
    {
      key: "locale_de_46json_96bd13ad",
      load: () => import("#nuxt-i18n/96bd13ad" /* webpackChunkName: "locale_de_46json_96bd13ad" */),
      cache: true
    }
  ],
  br_fr: [
    {
      key: "locale_fr_46json_0b687afd",
      load: () => import("#nuxt-i18n/0b687afd" /* webpackChunkName: "locale_fr_46json_0b687afd" */),
      cache: true
    }
  ],
  br_en: [
    {
      key: "locale_en_46json_76ef8785",
      load: () => import("#nuxt-i18n/76ef8785" /* webpackChunkName: "locale_en_46json_76ef8785" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    jit: true,
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "de",
      name: "Deutsch",
      iso: "de-CH",
      language: "de",
      domain: "gemini.ch",
      files: [
        "/vercel/path0/i18n/locales/de.json"
      ]
    },
    {
      code: "fr",
      name: "Français",
      iso: "fr-CH",
      language: "fr",
      domain: "gemini.ch",
      files: [
        "/vercel/path0/i18n/locales/fr.json"
      ]
    },
    {
      code: "en",
      name: "English",
      iso: "en-UK",
      language: "en",
      domain: "gemini.ch",
      files: [
        "/vercel/path0/i18n/locales/en.json"
      ]
    },
    {
      code: "br_de",
      name: "Deutsch Geschäftsberichte",
      iso: "de-CH",
      language: "de",
      domains: [
        "localhost:3001",
        "report.gemini-web.cherry.novu.ch",
        "report.gemini.ch"
      ],
      defaultForDomains: [
        "report.gemini-web.cherry.novu.ch",
        "report.gemini.ch"
      ],
      isBusinessReport: true,
      files: [
        "/vercel/path0/i18n/locales/de.json"
      ]
    },
    {
      code: "br_fr",
      name: "Français Rapport Annuel",
      iso: "fr-CH",
      language: "fr",
      domains: [
        "localhost:3001",
        "report.gemini-web.cherry.novu.ch",
        "report.gemini.ch"
      ],
      isBusinessReport: true,
      files: [
        "/vercel/path0/i18n/locales/fr.json"
      ]
    },
    {
      code: "br_en",
      name: "English Business Report",
      iso: "en-UK",
      language: "en",
      domains: [
        "localhost:3001",
        "report.gemini-web.cherry.novu.ch",
        "report.gemini.ch"
      ],
      isBusinessReport: true,
      files: [
        "/vercel/path0/i18n/locales/en.json"
      ]
    }
  ],
  defaultLocale: "de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: true,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "de",
    name: "Deutsch",
    iso: "de-CH",
    language: "de",
    domain: "gemini.ch",
    files: [
      {
        path: "/vercel/path0/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    name: "Français",
    iso: "fr-CH",
    language: "fr",
    domain: "gemini.ch",
    files: [
      {
        path: "/vercel/path0/i18n/locales/fr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    name: "English",
    iso: "en-UK",
    language: "en",
    domain: "gemini.ch",
    files: [
      {
        path: "/vercel/path0/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "br_de",
    name: "Deutsch Geschäftsberichte",
    iso: "de-CH",
    language: "de",
    domains: [
      "localhost:3001",
      "report.gemini-web.cherry.novu.ch",
      "report.gemini.ch"
    ],
    defaultForDomains: [
      "report.gemini-web.cherry.novu.ch",
      "report.gemini.ch"
    ],
    isBusinessReport: true,
    files: [
      {
        path: "/vercel/path0/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "br_fr",
    name: "Français Rapport Annuel",
    iso: "fr-CH",
    language: "fr",
    domains: [
      "localhost:3001",
      "report.gemini-web.cherry.novu.ch",
      "report.gemini.ch"
    ],
    isBusinessReport: true,
    files: [
      {
        path: "/vercel/path0/i18n/locales/fr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "br_en",
    name: "English Business Report",
    iso: "en-UK",
    language: "en",
    domains: [
      "localhost:3001",
      "report.gemini-web.cherry.novu.ch",
      "report.gemini.ch"
    ],
    isBusinessReport: true,
    files: [
      {
        path: "/vercel/path0/i18n/locales/en.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/